module.exports = __webpack_public_path__ + "static/media/landing-page-background.f587ec96.png";